import React, { useEffect, useRef, useState } from "react";
import "./whatsapp.scss"

import { Avatar, Dropdown, Modal, message } from "antd";
import { MoreOutlined, DeleteOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { deleteChat } from "../../../../../core/data/redux/slices/WabaChatSlice";
import api from "../../../../../core/axios/axiosInstance";



const countryNames = new Intl.DisplayNames(["en"], { type: "region" });
const formatFlowFieldValue = (key, val) => {
    if (key === "country" && typeof val === "string" && val.length === 2) {
        try { return countryNames.of(val.toUpperCase()) || val; } catch { return val; }
    }
    return String(val);
};

const getDateLabel = (dateStr) => {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    const fmt = (d) => d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
    if (dateStr === fmt(today)) return "Today";
    if (dateStr === fmt(yesterday)) return "Yesterday";
    return dateStr;
};

const ChatWindow = ({ conversation, onOpenContact, messagePagination, onLoadMore, isLoadingMore, isLoadingMessages }) => {
    const messagesContainerRef = useRef(null);
    const messagesEndRef = useRef(null);
    const prevScrollHeightRef = useRef(null);
    const isLoadingMoreRef = useRef(false);
      const userProfile = useSelector((state) => state.profile);
    const wabaTemplates = useSelector((state) => state.wabaTemplate.wabaTemplates || []);
    // useEffect(() => {
    //     if (messagesEndRef.current) {
    //         messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    //     }
    // }, [conversation?.messages]); // Trigger on new messages
    useEffect(() => {
        const container = messagesContainerRef.current;
        if (!container) return;

        if (prevScrollHeightRef.current !== null) {
            // Restore scroll position after prepend
            container.scrollTop = container.scrollHeight - prevScrollHeightRef.current;
            prevScrollHeightRef.current = null;
        } else if (!isLoadingMessages) {
            // New message arrived — scroll to bottom (skip if skeleton is showing)
            messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
        }
    }, [conversation?.messages]);



    const handleLoadMoreClick = async () => {
        const container = messagesContainerRef.current;
        if (container) {
            prevScrollHeightRef.current = container.scrollHeight; // 👈 save BEFORE fetch
        }
        isLoadingMoreRef.current = true;
        await onLoadMore(); // calls the parent's handleLoadMore
        isLoadingMoreRef.current = false;
    };


    const dispatch = useDispatch();

    const [fullscreenImage, setFullscreenImage] = useState(null);
    const [clickedButtons, setClickedButtons] = useState({});
    const [listModal, setListModal] = useState(null); // { title, sections }


    useEffect(() => {
        if (messagesContainerRef.current) {
            messagesContainerRef.current.scrollTop =
                messagesContainerRef.current.scrollHeight;
        }
    }, [conversation?.id]);

    useEffect(() => {
        if (!isLoadingMessages) {
            const id = setTimeout(() => {
                if (messagesContainerRef.current) {
                    messagesContainerRef.current.scrollTop =
                        messagesContainerRef.current.scrollHeight;
                }
            }, 0);
            return () => clearTimeout(id);
        }
    }, [isLoadingMessages]);



    const handleDeleteChat = () => {
        Modal.confirm({
            title: "Delete Chat",
            icon: <ExclamationCircleOutlined />,
            content: "Are you sure you want to delete this chat?",
            okText: "Yes, Delete",
            okType: "danger",
            cancelText: "Cancel",
            onOk: async () => {
                try {
                    console.log(conversation.id, "hjgfdghvjb");
                    const payload = {
                        conversationIds: [conversation.id]
                    }
                    await api.delete("/api/whatsapp/delete-chats", {
                        data: payload,
                    });


                    dispatch(deleteChat(conversation.id));

                    message.success("Chat deleted successfully");
                } catch (error) {
                    console.error("Delete failed", error);
                    message.error("Failed to delete chat");
                }
            },
        });
    };


    const getMsgTick = (status, from) => {
        if (from !== "agent") return null;
        if (status === "read") {
            return (
                <svg viewBox="0 0 16 11" width="16" height="11" style={{ display: "inline" }}>
                    <path d="M11.071.653a.5.5 0 0 0-.707.01L4.801 6.517 2.647 4.361a.5.5 0 1 0-.707.707l2.5 2.5a.5.5 0 0 0 .712-.005l5.924-6.204a.5.5 0 0 0-.005-.706z" fill="#53bdeb"/>
                    <path d="M14.571.653a.5.5 0 0 0-.707.01L8.301 6.517l-.91-.91-.707.707 1.263 1.263a.5.5 0 0 0 .712-.005l5.924-6.204a.5.5 0 0 0-.012-.715z" fill="#53bdeb"/>
                </svg>
            );
        }
        if (status === "delivered") {
            return (
                <svg viewBox="0 0 16 11" width="16" height="11" style={{ display: "inline" }}>
                    <path d="M11.071.653a.5.5 0 0 0-.707.01L4.801 6.517 2.647 4.361a.5.5 0 1 0-.707.707l2.5 2.5a.5.5 0 0 0 .712-.005l5.924-6.204a.5.5 0 0 0-.005-.706z" fill="#8696a0"/>
                    <path d="M14.571.653a.5.5 0 0 0-.707.01L8.301 6.517l-.91-.91-.707.707 1.263 1.263a.5.5 0 0 0 .712-.005l5.924-6.204a.5.5 0 0 0-.012-.715z" fill="#8696a0"/>
                </svg>
            );
        }
        if (status === "sent") {
            return (
                <svg viewBox="0 0 10 11" width="10" height="11" style={{ display: "inline" }}>
                    <path d="M9.071.653a.5.5 0 0 0-.707.01L2.801 6.517.647 4.361a.5.5 0 1 0-.707.707l2.5 2.5a.5.5 0 0 0 .712-.005L9.076 1.36a.5.5 0 0 0-.005-.706z" fill="#8696a0"/>
                </svg>
            );
        }
        if (status === "failed") {
            return <span style={{ color: "#e53935", fontSize: 12, fontWeight: 700 }}>!</span>;
        }
        return null;
    };

    const getDocIcon = (mime) => {
        if (!mime) return "📎";
        if (mime.includes("pdf")) return "📄";
        if (mime.includes("word")) return "📝";
        if (mime.includes("excel") || mime.includes("spreadsheet")) return "📊";
        if (mime.includes("presentation")) return "📽";
        if (mime.includes("zip") || mime.includes("rar")) return "📦";
        return "📎";
    };
    const avatarSrc =
        typeof conversation?.image === "string" && conversation.image.trim() !== ""
            ? conversation.image
            : undefined;

    return (
        <div className="chat-window">
            {conversation ? (
                <>
                    <div className="chat-header">
                        <div className="chat-header-left" onClick={onOpenContact}>

                            <Avatar src={avatarSrc} size={40}>
                                {(conversation?.chatName || conversation?.originalName || conversation?.from || "?").charAt(0)}
                            </Avatar>
                            <div>
                                <strong>{conversation?.chatName || conversation?.originalName || conversation?.from}</strong>
                                <div className="chat-phone">{conversation?.phone}</div>
                            </div>
                        </div>
                        {userProfile.role=="companyAdmin" &&<Dropdown
                            menu={{
                                items: [
                                    {
                                        key: "delete",
                                        label: "Delete Chat",
                                        icon: <DeleteOutlined />,
                                        danger: true,
                                        onClick: handleDeleteChat,
                                    },
                                ],
                            }}
                            trigger={["click"]}
                        >
                            <MoreOutlined
                                style={{
                                    fontSize: "20px",
                                    cursor: "pointer",
                                    padding: "5px",
                                }}
                            />
                        </Dropdown>}

                    </div>


                    <div className="chat-messages" ref={messagesContainerRef}>
                        {isLoadingMessages ? (
                            <div style={{ height: "100%", boxSizing: "border-box", padding: "16px 12px", display: "flex", flexDirection: "column", justifyContent: "flex-end", gap: 14 }}>
                                {[
                                    { sent: false, width: 180 },
                                    { sent: true,  width: 140 },
                                    { sent: false, width: 220 },
                                    { sent: true,  width: 100 },
                                    { sent: false, width: 260 },
                                    { sent: true,  width: 80  },
                                    { sent: false, width: 160 },
                                    { sent: true,  width: 200 },
                                    { sent: false, width: 130 },
                                    { sent: true,  width: 170 },
                                    { sent: false, width: 210 },
                                    { sent: true,  width: 120 },
                                    { sent: false, width: 190 },
                                    { sent: true,  width: 150 },
                                ].map((b, i) => (
                                    <div key={i} style={{ display: "flex", justifyContent: b.sent ? "flex-end" : "flex-start", alignItems: "flex-end", gap: 8 }}>
                                        {!b.sent && <div className="contact-skel" style={{ width: 28, height: 28, borderRadius: "50%", flexShrink: 0 }} />}
                                        <div className="contact-skel" style={{ height: 36, width: b.width, borderRadius: b.sent ? "16px 16px 4px 16px" : "16px 16px 16px 4px" }} />
                                    </div>
                                ))}
                            </div>
                        ) : (
                        <>
                        {/* Load More Button */}
                        {messagePagination?.hasMore && (
                            <div style={{ textAlign: "center", padding: "10px 0" }}>
                                <button
                                    className="btn btn-sm btn-secondary"
                                    onClick={handleLoadMoreClick}
                                    disabled={isLoadingMore}
                                >
                                    {isLoadingMore ? "Loading..." : "Load older messages"}
                                </button>
                            </div>
                        )}

                        {(() => {
                            let lastDate = null;
                            return conversation?.messages?.map((msg) => {
                            const showDateDivider = msg.date !== lastDate;
                            if (showDateDivider) lastDate = msg.date;
                            return (<React.Fragment key={msg?.id}>
                            {showDateDivider && (
                                <div className="wa-date-divider">
                                    <span>{getDateLabel(msg.date)}</span>
                                </div>
                            )}
                                <div
                                    className={`message ${msg?.from === "agent" ? "sent" : "received"}${(msg.type === "template" || (msg.type === "interactive" && msg.from === "agent")) ? " template-msg" : ""}`}
                                >
                                    {msg.type === "text" && typeof msg.text === "string" && (
                                        <span>{msg.text}</span>
                                    )}

                                    {msg.type === "button" && (
                                        <div className="qr-reply-bubble">
                                            <span>↩️</span>
                                            <span>{msg.buttonReply?.text || msg.text}</span>
                                        </div>
                                    )}
                                    {msg.type === "image" && (
                                        msg.media?.url ? (
                                            <>
                                                <img
                                                    src={msg.media.url}
                                                    alt="received"
                                                    className="chat-image"
                                                    onClick={() => setFullscreenImage(msg.media.url)}
                                                />
                                                <div>{msg.media.attachmentCaption}</div>
                                            </>
                                        ) : (
                                            <div style={{ color: "#9ca3af", fontSize: 12, fontStyle: "italic" }}>📷 Photo (unavailable)</div>
                                        )
                                    )}

                                    {fullscreenImage && (
                                        <div className="fullscreen-modal">
                                            <button className="close-btn" onClick={() => setFullscreenImage(null)}>
                                                ✕
                                            </button>
                                            <a href={fullscreenImage} download className="download-btn">
                                                ⬇
                                            </a>
                                            <img src={fullscreenImage} alt="fullscreen" className="fullscreen-img" />
                                        </div>
                                    )}

                                    {msg.type === "video" && (
                                        msg.media?.url ? (
                                            <> <video controls className="chat-video">
                                                <source src={msg.media.url} type={msg.media.mimeType} />
                                            </video>
                                                <div>{msg.media.attachmentCaption}</div>
                                            </>
                                        ) : (
                                            <div style={{ color: "#9ca3af", fontSize: 12, fontStyle: "italic" }}>🎥 Video (unavailable)</div>
                                        )
                                    )}
                                    {msg.type === "audio" && (
                                        msg.media?.url ? (
                                            <>  <audio controls src={msg.media.url} />
                                                <div>{msg.media.attachmentCaption}</div>
                                            </>
                                        ) : (
                                            <div style={{ color: "#9ca3af", fontSize: 12, fontStyle: "italic" }}>🎵 Audio (unavailable)</div>
                                        )
                                    )}
                                    {msg.type === "document" && (
                                        msg.media?.url ? (
                                            <> <a href={msg.media.url} target="_blank" rel="noreferrer">
                                                {getDocIcon(msg.media.mimeType)} {msg.media.attachmentName || msg.media.fileName}
                                            </a>
                                                <div>{msg.media.attachmentCaption}</div>
                                            </>
                                        ) : (
                                            <div style={{ color: "#9ca3af", fontSize: 12, fontStyle: "italic" }}>📄 Document (unavailable)</div>
                                        )
                                    )}

                                    {msg.type === "location" &&
                                        msg.location?.latitude &&
                                        msg.location?.longitude && (
                                            <div className="location-card">
                                                <a
                                                    href={`https://www.google.com/maps?q=${msg.location.latitude},${msg.location.longitude}`}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    <img
                                                        className="location-map"
                                                        src={`https://maps.wikimedia.org/img/osm-intl,15,${msg.location.latitude},${msg.location.longitude},300x160.png`}
                                                        alt="location"
                                                    />
                                                </a>

                                                <div className="location-info">
                                                    <strong>{msg.location.name || "Location"}</strong>

                                                    {msg.location.address && (
                                                        <div className="location-address">
                                                            {msg.location.address}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}

                                    {msg.type === "contacts" &&
                                        Array.isArray(msg.contacts) &&
                                        msg.contacts.map((c, i) => (
                                            <div key={i} className="contact-card">
                                                <Avatar size={36}>
                                                    {c.name?.charAt(0)}
                                                </Avatar>

                                                <div className="contact-info">
                                                    <strong>{c.name}</strong>

                                                    {Array.isArray(c.phones) &&
                                                        c.phones.map((p, j) => (
                                                            <div key={j} className="contact-phone">
                                                                {p.phone}
                                                            </div>
                                                        ))}
                                                </div>
                                            </div>
                                        ))}

                                    {msg.type === "template" && (() => {
                                        // msg.template.components may be absent for automation-sent templates;
                                        // fall back to the stored wabaTemplate by name so content still renders.
                                        const storedTpl = wabaTemplates.find(t => t.name === msg.template?.name);
                                        const components = (msg.template?.components?.length ? msg.template.components : storedTpl?.components) || [];
                                        const normalizeType = (t) => (t || "").toUpperCase();
                                        return (
                                        <div className="template-card">
                                            {/* ── Content ── */}
                                            <div className="template-card-body">
                                                {components.map((c, i) => {
                                                    const ctype = normalizeType(c.type);
                                                    if (ctype === "HEADER") {
                                                        const format = c.format?.toLowerCase();
                                                        const media = c.media;
                                                        if (format === "text") return (
                                                            <div key={i} className="tc-header">{c.text}</div>
                                                        );
                                                        if (format === "image" && media?.s3Url) return (
                                                            <img key={i} src={media.s3Url} alt="header" className="tc-media" onClick={() => setFullscreenImage(media.s3Url)} />
                                                        );
                                                        if (format === "video" && media?.s3Url) return (
                                                            <video key={i} controls className="tc-media"><source src={media.s3Url} type={media.mimeType} /></video>
                                                        );
                                                        if (format === "document") return (
                                                            <div key={i} className="tc-document">📄 {media?.fileName || "Document"}</div>
                                                        );
                                                    }
                                                    if (ctype === "BODY") return (
                                                        <div key={i} className="tc-body">{c.text}</div>
                                                    );
                                                    if (ctype === "FOOTER") return (
                                                        <div key={i} className="tc-footer">{c.text}</div>
                                                    );
                                                    return null;
                                                })}
                                                {components.length === 0 && msg.template?.name && (
                                                    <div className="tc-body" style={{ color: "#8696a0" }}>📄 {msg.template.name}</div>
                                                )}
                                            </div>

                                            {/* ── Buttons ── */}
                                            {components
                                                .filter(c => normalizeType(c.type) === "BUTTONS")
                                                .map((c, bi) => (
                                                    <div key={bi} className="tc-buttons">
                                                        {c.buttons.map((btn, j) => {
                                                            const key = `${msg.id}-${bi}-${j}`;
                                                            const isClicked = clickedButtons[key];
                                                            const t = (btn.type || "").toUpperCase();
                                                            const icon = t === "URL" ? "🔗" : t === "PHONE_NUMBER" ? "📞" : t === "QUICK_REPLY" ? "↩️" : t === "COPY_CODE" ? "📋" : "";
                                                            const label = t === "COPY_CODE" ? (btn.text || "Copy Offer Code") : btn.text;

                                                            const handleClick = () => {
                                                                setClickedButtons(prev => ({ ...prev, [key]: true }));
                                                                if (t === "URL" && btn.url) window.open(btn.url, "_blank");
                                                                if (t === "PHONE_NUMBER" && btn.phone_number) window.open(`tel:${btn.phone_number}`);
                                                            };

                                                            return (
                                                                <button
                                                                    key={j}
                                                                    type="button"
                                                                    className={`tc-btn${isClicked ? " clicked" : ""}`}
                                                                    onClick={handleClick}
                                                                    disabled={isClicked}
                                                                >
                                                                    {icon && <span className="tc-btn-icon">{icon}</span>}
                                                                    <span>{label}</span>
                                                                </button>
                                                            );
                                                        })}
                                                    </div>
                                                ))
                                            }

                                            {/* ── Time + tick inside card ── */}
                                            <div className="tc-time">
                                                <span>{msg.date} &nbsp;{msg.time}</span>
                                                <span style={{ lineHeight: 1 }}>{getMsgTick(msg.status, msg.from)}</span>
                                            </div>
                                        </div>
                                        );
                                    })()}

                                    {msg.type === "interactive" && msg.from === "user" && !msg.flowResponseData && (
                                        <div className="qr-reply-bubble">
                                            <span>↩️</span>
                                            <span>{msg.text || msg.interactive?.title || "Selected option"}</span>
                                        </div>
                                    )}

                                    {msg.type === "interactive" && msg.from === "user" && msg.flowResponseData && (() => {
                                        const fields = Object.entries(msg.flowResponseData)
                                            .filter(([k]) => !["flow_token", "version"].includes(k));
                                        return (
                                            <div style={{
                                                minWidth: 220, maxWidth: 280,
                                                borderRadius: 10,
                                                overflow: "hidden",
                                                background: "#fff",
                                                boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
                                                border: "1px solid #e5e7eb",
                                            }}>
                                                {/* Header */}
                                                <div style={{
                                                    background: "linear-gradient(135deg, #3C2371 0%, #5c3a9e 100%)",
                                                    padding: "10px 14px",
                                                    display: "flex", alignItems: "center", gap: 8,
                                                }}>
                                                    <div style={{
                                                        width: 28, height: 28, borderRadius: "50%",
                                                        background: "rgba(255,255,255,0.2)",
                                                        display: "flex", alignItems: "center", justifyContent: "center",
                                                        fontSize: 14, flexShrink: 0,
                                                    }}>✓</div>
                                                    <div>
                                                        <div style={{ color: "#fff", fontSize: 13, fontWeight: 600, lineHeight: 1.2 }}>{msg.flowName || "Form Submitted"}</div>
                                                        <div style={{ color: "rgba(255,255,255,0.72)", fontSize: 10, marginTop: 1 }}>{fields.length} field{fields.length !== 1 ? "s" : ""} captured</div>
                                                    </div>
                                                </div>

                                                {/* Fields */}
                                                {fields.length > 0 && (
                                                    <div style={{ padding: "8px 0" }}>
                                                        {fields.map(([key, val], i) => (
                                                            <div key={i} style={{
                                                                padding: "5px 14px",
                                                                borderBottom: i < fields.length - 1 ? "1px solid #f3f4f6" : "none",
                                                            }}>
                                                                <div style={{ fontSize: 10, color: "#9ca3af", fontWeight: 500, textTransform: "uppercase", letterSpacing: 0.4, marginBottom: 1 }}>
                                                                    {key.replace(/_/g, " ")}
                                                                </div>
                                                                <div style={{ fontSize: 13, color: "#111827", fontWeight: 500, wordBreak: "break-word" }}>
                                                                    {formatFlowFieldValue(key, val) || <span style={{ color: "#d1d5db", fontStyle: "italic" }}>—</span>}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}

                                                {/* Timestamp */}
                                                <div style={{
                                                    display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 4,
                                                    padding: "4px 10px 7px",
                                                    background: "#f9fafb",
                                                    borderTop: "1px solid #f3f4f6",
                                                }}>
                                                    <span style={{ fontSize: 10, color: "#9ca3af" }}>{msg.date} &nbsp;{msg.time}</span>
                                                    <span style={{ lineHeight: 1, fontSize: 11 }}>{getMsgTick(msg.status, msg.from)}</span>
                                                </div>
                                            </div>
                                        );
                                    })()}

                                    {msg.type === "interactive" && msg.from === "agent" && (
                                        <div className="template-card">
                                            <div className="template-card-body">
                                            {msg.interactive?.header && (
                                                <div className="tc-header">
                                                    {msg.interactive.header?.text || msg.interactive.header}
                                                </div>
                                            )}
                                            <div className="tc-body">
                                                {msg.interactive?.body?.text || msg.interactive?.body || msg.text}
                                            </div>
                                            {msg.interactive?.footer && (
                                                <div className="tc-footer">
                                                    {msg.interactive.footer?.text || msg.interactive.footer}
                                                </div>
                                            )}
                                            </div>
                                            {(msg.interactive?.type === "button" || msg.interactive?.type === "cta_url") && (
                                                <div className="tc-buttons">
                                                    {(msg.interactive?.action?.buttons || msg.interactive?.buttons || []).map((btn, i) => (
                                                        <button
                                                            key={i}
                                                            type="button"
                                                            className="tc-btn"
                                                            onClick={() => btn.url && window.open(btn.url, "_blank")}
                                                        >
                                                            <span className="tc-btn-icon">{btn.type === "cta_url" ? "🔗" : "↩️"}</span>
                                                            <span>{btn.text || btn.title}</span>
                                                        </button>
                                                    ))}
                                                </div>
                                            )}
                                            {msg.interactive?.type === "list" && (
                                                <div className="tc-buttons">
                                                    <button
                                                        type="button"
                                                        className="tc-btn"
                                                        style={{ color: "#3C2371" }}
                                                        onClick={() => setListModal({
                                                            title: msg.interactive?.buttonLabel || msg.interactive?.action?.button || "Options",
                                                            sections: msg.interactive?.sections || msg.interactive?.action?.sections || [],
                                                        })}
                                                    >
                                                        <span className="tc-btn-icon">☰</span>
                                                        <span>{msg.interactive?.buttonLabel || msg.interactive?.action?.button || "View Options"}</span>
                                                    </button>
                                                </div>
                                            )}
                                            {msg.interactive?.type === "flow" && (
                                                <div className="tc-buttons">
                                                    <button type="button" className="tc-btn" style={{ color: "#3C2371" }}>
                                                        <span className="tc-btn-icon">📋</span>
                                                        <span>{msg.interactive?.action?.parameters?.flow_cta || "Open Form"}</span>
                                                    </button>
                                                </div>
                                            )}
                                            <div className="tc-time">
                                                <span>{msg.date} &nbsp;{msg.time}</span>
                                                <span style={{ lineHeight: 1 }}>{getMsgTick(msg.status, msg.from)}</span>
                                            </div>
                                        </div>
                                    )}

                                    {msg.type !== "template" && !(msg.type === "interactive" && msg.from === "agent") && (
                                        <div className="wa-msg-meta">
                                            <span className="wa-msg-time">{msg.time}</span>
                                            <span style={{ lineHeight: 1 }}>{getMsgTick(msg.status, msg.from)}</span>
                                        </div>
                                    )}
                                </div>
                            </React.Fragment>);
                        });
                        })()}
                        <div ref={messagesEndRef} />
                        </>
                        )}
                    </div>
                </>
            )



                :
                <div className="chat-area-empty">
                    <img
                        src="/assets/img/icons/whatsappIcon96.png"
                        alt="WhatsApp Business"
                        className="empty-image"
                    />
                    <h2 className="pb-2">Welcome to Your Business Inbox</h2>
                    <p>
                        Select a conversation to start messaging your customers. <br />
                        All your chats will appear here once selected.
                    </p>
                </div>
            }

            {/* ── View Options modal (list-type interactive) ── */}
            <Modal
                open={!!listModal}
                onCancel={() => setListModal(null)}
                footer={null}
                title={
                    <span style={{ color: "#3C2371", fontWeight: 700, fontSize: 15 }}>
                        ☰ {listModal?.title}
                    </span>
                }
                styles={{ header: { borderBottom: "2px solid #ede7f6" } }}
                width={340}
                centered
            >
                {listModal?.sections?.map((section, si) => (
                    <div key={si} style={{ marginBottom: 12 }}>
                        {section.title && (
                            <div style={{
                                fontSize: 11, fontWeight: 700, color: "#3C2371",
                                textTransform: "uppercase", letterSpacing: 0.6,
                                padding: "6px 0 4px", borderBottom: "1px solid #ede7f6",
                                marginBottom: 6,
                            }}>
                                {section.title}
                            </div>
                        )}
                        {(section.rows || []).map((row, ri) => (
                            <div key={ri} style={{
                                padding: "10px 12px",
                                borderRadius: 8,
                                marginBottom: 4,
                                background: "#fafafa",
                                border: "1px solid #f0f0f0",
                                cursor: "default",
                            }}>
                                <div style={{ fontWeight: 600, fontSize: 13, color: "#111827" }}>
                                    {row.title}
                                </div>
                                {row.description && (
                                    <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 2 }}>
                                        {row.description}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                ))}
                {(!listModal?.sections || listModal.sections.length === 0) && (
                    <p style={{ color: "#9ca3af", textAlign: "center", margin: "16px 0" }}>No options available.</p>
                )}
            </Modal>
        </div>
    );
};
export default ChatWindow;